













import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { INaturalTextBehavior } from "../../../../domain/format/objects";
import { default as OptionalFeatureEditor } from "./OptionalFeatureEditor.vue";

@Component({
  components: {
    OptionalFeatureEditor,
  },
})
export default class NaturalTextBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: INaturalTextBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: INaturalTextBehavior) => T, defaultValue: T) => T;

  $refs!: {
    input: HTMLInputElement;
  };

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  get text(): string {
    return this.readPropertyOrDefault(s => s.text, "");
  }

  set text(value: string) {
    this.writePropertyWhenValid(s => s.text = value);
  }
}
